import { createContext, useContext, useEffect } from "react";

/**
 * Allows modal content to register a badge/supplement that renders inline with the modal title (h2).
 */
export const ModalTitleBadgeContext = createContext(null);

/**
 * Set the modal title badge. Shown inline with the title in the header.
 * Clears on unmount.
 * @param {React.ReactNode} badge - Badge content (e.g. Beta label)
 * @param {Array} deps - Optional dependency array
 */
export function useModalTitleBadge(badge, deps = []) {
  const value = useContext(ModalTitleBadgeContext);
  const setBadge = value?.[1];
  useEffect(() => {
    if (setBadge) setBadge(badge ?? null);
    return () => {
      if (setBadge) setBadge(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps intentionally control when to push latest
  }, [setBadge, ...deps]);
}
